import React, { useState } from "react";
import {
  Card,
  CardBody,
  CardFooter,
  CardHeader,
  CardHeaderToolbar
} from "../../../../../_metronic/_partials/controls";
import { Form as Forms } from "react-bootstrap";
import { toAbsoluteUrl } from "../../../../../_metronic/_helpers";
import "./style.css";
import SVG from "react-inlinesvg";
import { BlockOrg } from "../../../../RoleChecker";
import { ProjectImageForm } from "./ProjectImageForm";
import { useSelector } from "react-redux";

export default function ProjectImage({
  uploadProjectImage,
  images = [],
  removeImage,
  deletedImage = [],
  deleteImage
}) {
  const blockOrg = BlockOrg();
  const { actionsLoading } = useSelector(({ project }) => ({
    actionsLoading: project.actionsLoading
  }));

  const [showImageModal, setShowImageModal] = useState(false);

  return (
    <>
      {blockOrg && (
        <ProjectImageForm
          show={showImageModal}
          onHide={() => setShowImageModal(false)}
          loading={actionsLoading}
          submit={uploadProjectImage}
        />
      )}
      <Card>
        <CardHeader title="Gallery">
          <CardHeaderToolbar>
            {blockOrg && (
              <button
                className="btn btn-primary mr-2"
                onClick={() => setShowImageModal(true)}
              >
                Tambah Foto
              </button>
            )}
          </CardHeaderToolbar>
        </CardHeader>
        <CardBody>
          <div
            style={{
              display: "flex",
              flexWrap: "wrap",
              justifyContent: "center"
            }}
          >
            {images.map(item => (
              <>
                <div
                  className="d-flex flex-column"
                  style={{
                    flex: "0 1 23%",
                    margin: 4,
                    textAlign: "center"
                  }}
                >
                  {/* <img
                    maxWidth={180}
                    height={100}
                    src={`${item.storage}/${item.path}`}
                  ></img> */}
                  <div
                    style={{
                      backgroundImage: `url(${item.storage}/${item.path})`,
                      backgroundPosition: "center",
                      backgroundSize: "contain",
                      backgroundRepeat: "no-repeat",
                      height: "100px",
                      maxWidth: "180px"
                    }}
                  >
                    <div className="overlay-image-text">{""}</div>
                    {blockOrg && (
                      <div className="image-tool">
                        <label
                          title="Delete image"
                          className="btn btn-icon btn-light btn-hover-danger btn-sm"
                          onClick={() => removeImage(item)}
                        >
                          <span className="svg-icon svg-icon-md svg-icon-danger">
                            <SVG
                              src={toAbsoluteUrl(
                                "/media/svg/icons/General/Trash.svg"
                              )}
                            />
                          </span>
                        </label>
                      </div>
                    )}
                  </div>
                  <h5 className="h5 mt-2">
                    {(item.project_file && item.project_file.caption) ?? ""}
                  </h5>
                </div>
              </>
            ))}
          </div>
        </CardBody>
        <CardFooter>
          {deletedImage.length > 0 && (
            <button
              className="btn btn-danger float-right"
              onClick={deleteImage}
            >
              Hapus ({deletedImage.length})
            </button>
          )}
        </CardFooter>
      </Card>
    </>
  );
}
